import React from 'react';

import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import type { HTMLBlockProps } from './interfaces';

const HTMLBlock = ({ html }: HTMLBlockProps) => {
  return <div className="html-block">{AuthoredContentReactToHtmlParser(html)}</div>;
};

export default HTMLBlock;
